import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useFaction } from "@/contexts/FactionContext";
import { useAuth } from "@/contexts/AuthContext";
import { playMusic, preloadSfx, installClickSound, stopAllLoops } from "@/lib/audio";
import { friendsApi } from "@/lib/friends";
import MusicButton from "@/components/MusicButton";
import InviteWatcher from "@/components/InviteWatcher";
// Picks the background music for the current page, shows the floating
// music button, sends the friends "I'm online" heartbeat every 60 s and
// shows game invites.
//   • In a game (/game/... or /faction-wars/...) → "game" context.
//   • Everywhere else → "menu" context.
export default function MusicDirector() {
  const location = useLocation();
  const { faction } = useFaction();
  const { user } = useAuth();
  const gameMatch = location.pathname.match(/^\/(?:game|faction-wars)\/([^/]+)/);
  const gameId = gameMatch ? gameMatch[1] : null;
  const inGame = !!gameMatch;
  useEffect(() => {
    preloadSfx();
    installClickSound();
  }, []);
  useEffect(() => {
    playMusic(inGame ? "game" : "menu");
    if (!inGame) stopAllLoops();
  }, [inGame, faction]);
  useEffect(() => {
    if (!user) return undefined;
    friendsApi.heartbeat(gameId);
    const id = setInterval(() => friendsApi.heartbeat(gameId), 60000);
    return () => clearInterval(id);
  }, [user, gameId]);
  return (
    <>
      <MusicButton />
      <InviteWatcher />
    </>
  );
}
